var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pipeline-renderer',{attrs:{"value":_vm.value,"pipeline-id":_vm.params.pipelineId}})}
var staticRenderFns = []

export { render, staticRenderFns }